import { CardData, CardTemplate } from 'types/story';
import { CardEvent } from 'common/utils/facades/templates/card-event';
import { FLOAT_ABOVE } from 'client/components/common/BuildingBlocks/FloatAbove';
import { FLOAT_BELOW } from 'client/components/common/BuildingBlocks/FloatBelow';
import { CONTENT } from 'client/components/common/BuildingBlocks/Content';
import { CARD } from 'client/components/common/BuildingBlocks/Card';
import { generateCardId } from 'common/utils/generate-id';

interface Props {
	type: CardData['type'];
	name: string;
}

export function defaultTemplate({ type, name }: Props): CardTemplate {
	const cardId = generateCardId();
	return {
		id: '',
		name: 'Blank page',
		subtitle: 'Blank template.',
		description: 'Blank template to build your card from scratch.',
		organizationId: null,
		editor: {
			card: {
				_id: cardId,
				type,
				name,
				elements: [
					FLOAT_ABOVE().model,
					// @ts-expect-error ts-migrate FIXME
					CONTENT().model,
					FLOAT_BELOW().model,
					// @ts-expect-error ts-migrate FIXME
					CARD().model,
				],
				settings: {},
				events: [CardEvent()],
			},
		},
		metadata: {
			storySettings: {
				cards: {
					[cardId]: {},
				},
			},
			storyId: '',
			cardId: '',
			clientStoryId: '',
			version: process.env.VERSION as string,
			defaultPlatform: 'default',
		},
		type: 'card',
		language: '',
		categories: [],
	};
}
